exports = module.exports = require("./node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\nul li{\n    margin: 0;\n    padding: 0;\n}\nul {\n    list-style: none;\n}\n", "", {"version":3,"sources":["/./app.vue?79c04b0c"],"names":[],"mappings":";AAyBA;IACA,UAAA;IACA,WAAA;CACA;AACA;IACA,iBAAA;CACA","file":"app.vue","sourcesContent":["<template>\n    <vue-antiscroll :height=\"300\">\n        <ul>\n            <li v-for=\"item in arr\">\n                {{item.name}}\n            </li>\n        </ul>\n    </vue-antiscroll>\n</template>\n<script>\n    export default {\n    \tdata () {\n    \t\tlet arr = Array.apply(null, {length : 100}).map((el, index) => {\n    \t\t\treturn {\n    \t\t\t\tid: index,\n                    name: `xxxfsfsdfffff@第${index}个`\n                }\n            })\n    \t\treturn {\n    \t\t\tarr\n            }\n        }\n    }\n</script>\n<style>\n    ul li{\n        margin: 0;\n        padding: 0;\n    }\n    ul {\n        list-style: none;\n    }\n</style>"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-480ac1de","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./app.vue
// module id = 42
// module chunks = 0